module.exports = __webpack_public_path__ + "static/img/pro-4.1022014.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pro-4.png
// module id = 0CoF
// module chunks = 1